import { render, staticRenderFns } from "./NavbarSystemAdminMenu.vue?vue&type=template&id=9c63149a"
import script from "./NavbarSystemAdminMenu.vue?vue&type=script&lang=js"
export * from "./NavbarSystemAdminMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports